import { SVGProps } from 'react';

export const IconSupport = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 18 17' {...props}>
      <g transform='translate(.725 .5)' stroke='currentColor' fill='none' fillRule='evenodd'>
        <ellipse cx='7.979' cy='8' rx='7.533' ry='7.529' />
        <path d='M8.84 4.412c0 .176-.096.294-.24.294H7.408c-.143 0-.239-.118-.239-.294V.294c0-.176.096-.294.24-.294H8.6c.143 0 .238.118.238.294v4.118zM8.84 15.706c0 .176-.096.294-.24.294H7.408c-.143 0-.239-.118-.239-.294v-4.118c0-.176.096-.294.24-.294H8.6c.143 0 .238.118.238.294v4.118zM11.594 8.835c-.177 0-.294-.095-.294-.238V7.403c0-.143.117-.238.294-.238h4.12c.176 0 .294.095.294.238v1.194c0 .143-.118.238-.294.238h-4.12zM.294 8.835C.118 8.835 0 8.74 0 8.597V7.403c0-.143.118-.238.294-.238h4.12c.177 0 .294.095.294.238v1.194c0 .143-.117.238-.294.238H.294z' />
        <ellipse cx='7.979' cy='8' rx='3.767' ry='3.765' />
      </g>
    </svg>
  );
};
